import { useCallback, useEffect } from 'react';
import { debounce } from 'throttle-debounce';
import useWidgetContext from '../../common/react/useWidgetContext';

const useUpdateWidgetPadding = () => {
  const {
    configuration: { containerId, stickyParentHeaderSelector },
  } = useWidgetContext();

  if (!stickyParentHeaderSelector) {
    return;
  }

  const updateHeaderHeight = debounce(
    50,
    useCallback(() => {
      const containerPadding: string = document.getElementById(containerId).style.paddingTop;

      if (containerPadding !== retrieveHeaderHeight()) {
        document.getElementById(containerId).style.paddingTop = retrieveHeaderHeight() + 'px';
      }
    }, []),
  );

  const retrieveHeaderHeight = useCallback(
    () => document.getElementById(stickyParentHeaderSelector)?.offsetHeight.toString(),
    [],
  );

  window.addEventListener('resize', updateHeaderHeight);

  useEffect(() => {
    updateHeaderHeight();
  }, []);
};

export default useUpdateWidgetPadding;
